import React from 'react';
import { useTranslation } from 'react-i18next';
import "../styles/Partners.css";
import mountainBg from "../assets/image/mountain_village.png";

function PartnersHero() {
  const { t } = useTranslation();
  return (
    <section
      className="ap-hero"
      style={{ backgroundImage: `url(${mountainBg})` }}
    >
      <div className="ap-hero-overlay"></div>

      <div className="ap-hero-content">
        <span className="ap-hero-badge">{t('partners.badge')}</span>
        <h1 className="ap-hero-title">
          {t('partners.title1')} <span className="keyword">{t('partners.titleKeyword')}</span>
        </h1>
        <p className="ap-hero-sub">
          {t('partners.sub')}
        </p>
      </div>

      <div className="ap-hero-wave">
        <svg viewBox="0 0 1440 100" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill="var(--background-solid)"
            d="M0,100 L0,40 C360,100 1080,0 1440,60 L1440,100 Z"
          ></path>
        </svg>
      </div>
    </section>
  );
}

export default PartnersHero;
